// Add request cancellation and debouncing
let activeRequests = [];
let lastRequestTime = 0;
const REQUEST_DEBOUNCE_DELAY = 300; // ms

document.addEventListener('click', (e) => {
  const swatch = e?.target?.closest('[data-swatch-value]');
  const image = e?.target?.closest('img');
  if (!swatch) return;
  
  const isSwatchActive = swatch.classList.contains('active');
  console.log('active', isSwatchActive);
  if (isSwatchActive) return;

  // Debounce rapid clicks
  const now = Date.now();
  if (now - lastRequestTime < REQUEST_DEBOUNCE_DELAY) {
    console.log('Request debounced - too rapid clicking');
    return;
  }
  lastRequestTime = now;
  if(image){
    let switch_image = image.getAttribute('src');
    console.log('switch_image', switch_image);
    if(switch_image){
      document.querySelector('.product_switch_loader .swatch_thumbnail').style.backgroundImage = `url(https:${switch_image})`;
    }
  }
  document.querySelector('.product_switch_loader')?.classList.add('active');
  
  const variantId = swatch.dataset.variant_id;
  console.log('Selected Variant ID:', variantId);

  const pdpHandle = swatch.dataset.product;
  
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
  
  // Cancel any pending requests
  cancelPendingRequests();
  
  updateVariantSections(variantId, pdpHandle);
});

// Function to cancel all active requests
function cancelPendingRequests() {
  activeRequests.forEach(controller => {
    if (controller && !controller.signal.aborted) {
      controller.abort();
    }
  });
  activeRequests = [];
}


// reinitialize judgeme
function initializeJudgeMeAfterInjection() {
  // Wait a bit for DOM to settle
  setTimeout(() => {
    if (typeof jdgm === 'undefined') {
      console.log('Judge.me not loaded yet, waiting...');
      setTimeout(initializeJudgeMeAfterInjection, 1000);
      return;
    }
    
    try {
      // Clear any existing widget state
      if (typeof jdgmCacheServer !== 'undefined' && typeof jdgmCacheServer.clearAll === 'function') {
        jdgmCacheServer.clearAll();
      }
      
      // Reinitialize using their preferred method
      if (typeof jdgmCacheServer !== 'undefined' && typeof jdgmCacheServer.reloadAll === 'function') {
        jdgmCacheServer.reloadAll();
      } else if (typeof jdgm.initializeWidgets === 'function') {
        jdgm.initializeWidgets();
      }
      
      // Re-apply customization
      if (typeof jdgm.customizeReviews === 'function') {
        setTimeout(() => jdgm.customizeReviews(), 300);
      }
      
    } catch (error) {
      console.error('Failed to initialize Judge.me:', error);
    }
  }, 1500); // Wait longer for everything to load
}

// Call this after you inject the HTML


async function updateVariantSections(variantId, pdpHandle) {
  console.log('Product Handle:', pdpHandle);
  
  const sectionsToUpdate = window?.productActiveSections;
  if (!sectionsToUpdate || sectionsToUpdate.length === 0) return;

  const baseUrl = `${window.location.origin}/products/${pdpHandle}`;

  // Update browser history
  const newUrl = `${window.location.origin}/products/${pdpHandle}`;
  window.history.pushState({}, '', newUrl);

  // Create AbortController for this request batch
  const controller = new AbortController();
  activeRequests.push(controller);
  let count = 1;
  // Fetch sections one by one
  for (const sectionId of sectionsToUpdate) {
    // Check if request was aborted
    if (controller.signal.aborted) {
      console.log('Request aborted for section:', sectionId);
      return;
    }

    const url = new URL(baseUrl);
    url.searchParams.set('variant', variantId);
    url.searchParams.set('sections', sectionId);

    console.log('Fetching:', url.toString());

    try {
      const response = await fetch(url, {
        signal: controller.signal
      });
      
      if (!response.ok) throw new Error(`Failed to fetch section: ${sectionId}`);

      const data = await response.json();

      // Replace the section content
      const html = data[sectionId];
      if (html) {
        const newContent = new DOMParser().parseFromString(html, 'text/html').querySelector(`#shopify-section-${sectionId}`);
        const oldContent = document.querySelector(`#shopify-section-${sectionId}`);
        if (newContent && oldContent) {
          oldContent.replaceWith(newContent);

          injectKlaviyoBISButton(newContent, variantId);
         
          let judgemeWidget = newContent.querySelector('#judgeme_product_reviews');

          let okendoReviewsWidget = newContent.querySelector('.okeReviews.oke-w');

          if(okendoReviewsWidget){
            if(okeWidgetApi && okeWidgetApi?.initAllWidgets){
              okeWidgetApi.initAllWidgets()
            }
          }
   
          if(judgemeWidget){
            initializeJudgeMeAfterInjection();
            // try {
            //   setTimeout(function(){
            //     window?.judgeme?.loadCSS();
            //     window?.judgeme?.initializeWidgets();

            //   },3000);
            // } catch (e) {
            //   console.error('Error in judgeme.initializeWidgets:', e);
            // }
          }
           count++;
          if(count == 2){
             document.querySelector('.product_switch_loader')?.classList.remove('active');
          }

        }
        
        // Initialize components with error handling
        
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('Request aborted for section:', sectionId);
        return;
      }
      console.error(`Error updating section ${sectionId}:`, error);
    }
  }
  safelyInitializeComponents();
  // Remove controller from active requests after completion
  activeRequests = activeRequests.filter(c => c !== controller);
}

// Safe initialization with error handling
function safelyInitializeComponents() {
  try {
    if(window?.initSubOptions){
      window?.initSubOptions();
    }
  } catch (e) {
    console.error('Error in initSubOptions:', e);
  }

  try{
    if(window?.quickAddToCart){
      window?.quickAddToCart()
    }
    
  } catch(e){
    console.error('Error in quick add to cart:', e);
  }
  
  try {
    if(window?.initProductCategory){

      window?.initProductCategory();
    }
  } catch (e) {
    console.error('Error in initProductCategory:', e);
  }
  
  try {
    if(window?.faqActivateFunc){

      window?.faqActivateFunc();
    }
  } catch (e) {
    console.error('Error in faqActivateFunc:', e);
  }
  
  try {
    if(window?.reinitTestimonialSlider){
      window?.reinitTestimonialSlider();
    }
  } catch (e) {
    console.error('Error in reinitTestimonialSlider:', e);
  }
  
  try {
    if(window?.initSupplementModal){
      window?.initSupplementModal();
    }
  } catch (e) {
    console.error('Error in initSupplementModal:', e);
  }
 
  
  // try {
  //   window?.judgeme?.loadCSS();
  // } catch (e) {
  //   console.error('Error in judgeme.loadCSS:', e);
  // }
  
  // Use requestAnimationFrame for smoother initialization
  
    
  
}

// ─── INJECT CUSTOM BIS BUTTON ────────────────────────────────────────
function injectKlaviyoBISButton(newContent, variantId) {
  const addToCartComponent = newContent.querySelector('add-to-cart-component');
  if (!addToCartComponent) return;

  const isOOS = addToCartComponent.querySelector('button[disabled]') !== null;
  
  if (!isOOS) {
    addToCartComponent.style.display = '';
    newContent.querySelector('#kl-bis-custom')?.remove();
    return;
  }

  // Hide the disabled sold-out button
  addToCartComponent.style.display = 'none';

  // Remove any previously injected BIS button
  newContent.querySelector('#kl-bis-custom')?.remove();

  // Build simple button that opens Klaviyo popup
  const wrapper = document.createElement('div');
  wrapper.id = 'kl-bis-custom';
  wrapper.style.cssText = 'margin-bottom: 10px; flex: 1 1 0%;';

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.textContent = 'Sold Out | Notify me when back in stock!';
  btn.style.cssText = `
    width: 100%;
    padding: 17px 20px;
    background-color: #921A27;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 700;
    line-height:130%;
    cursor: pointer;
    letter-spacing: 0;
    text-transform: none;
    border-radius: 28px;
    font-family: "Montserrat",sans-serif;
  `;

  btn.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();

    // Update the variant Klaviyo's form will subscribe to
    // by setting it on the page's product form before opening
    const variantInput = document.querySelector('form[action="/cart/add"] input[name="id"]');
    if (variantInput) variantInput.value = variantId;

    if (window.klaviyo) {
      window.klaviyo.openForm('Stdzb9');
    } else {
      console.warn('Klaviyo JS not loaded');
    }
  });

  wrapper.appendChild(btn);
  addToCartComponent.insertAdjacentElement('afterend', wrapper);
}

window.addEventListener('popstate', (event) => {
  console.log('Back or forward button clicked:', window.location.href);

  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get('variant');
  
  if (variantId) {
    const pdpHandle = window.location.pathname.split('/products/')[1];
    // Cancel any pending requests before handling popstate
    cancelPendingRequests();
    updateVariantSections(variantId, pdpHandle);
  }
});

// Also add cleanup when leaving the page
window.addEventListener('beforeunload', () => {
  cancelPendingRequests();
});